function getApiUrl() {
    if ((window as any).env === 'local') {
        return 'http://127.0.0.1:3010';
    } else if ((window as any).env === 'dev') {
        return 'http://127.0.0.1:3010';
    } else if ((window as any).env === 'staging') {
        return 'http://127.0.0.1:3010';
    } else if ((window as any).env === 'prod') {
        return 'http://127.0.0.1:3010';
    }
    return 'http://127.0.0.1:3010';
}
export const appConfig = {
    apiPrefix: `${getApiUrl()}/api`,
    baseApiUrl: getApiUrl(),
    // authenticatedEntryPath: appRoutes.dashboard.dashboard(),
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    enableMock: true,
};
export default appConfig;
